<template>
    <jet-form-section @submitted="updateTeamName">
        <template #title>
            Team Details
        </template>

        <template #description>
            The team's name, logo, and owner information.
        </template>

        <template #form>

            <div class="col-span-6 text-sm text-gray-800">Team Name & Logo can be updated in the <inertia-link
                    :href="route('settings.incoming')" class="text-blue-500 hover:underline">Recorder appearance
                    settings page</inertia-link>
            </div>
            <div v-if="false">
                <!-- Team Name -->
                <div class="col-span-2 flex flex-col justify-center">
                    <jet-label for="name" value="Team Name" />
                </div>
                <div class="col-span-4 flex flex-col justify-center">
                    <jet-input id="name" type="text" class="mt-1 block w-full max-w-80  text-sm" v-model="form.name"
                        :disabled="!permissions.canUpdateTeam" />

                    <jet-input-error :message="form.errors.name" class="mt-2" />
                </div>


                <!-- Profile Photo -->
                <div class="col-span-2 flex flex-col justify-center">
                    <jet-label for="photo" value="Team Logo" />
                </div>
                <div class="col-span-4 flex flex-col justify-center">
                    <!-- Profile Photo File Input -->
                    <input type="file" class="hidden" ref="photo" @change="updatePhotoPreview">

                    <!-- Current Team Logo -->
                    <div class="mt-2 " v-show="!photoPreview && hasLogo">
                        <img :src="team.team_logo_url" :alt="team.name" class="rounded-full h-20 w-20 object-cover"
                            :class="{ 'cursor-pointer hover:opacity-75': permissions.canUpdateTeam }"
                            @click.prevent="selectNewPhoto">
                    </div>

                    <!-- New Profile Photo Preview -->
                    <div class="mt-2" v-show="photoPreview && hasLogo">
                        <span class="block rounded-full w-20 h-20 cursor-pointer hover:opacity-75"
                            :style="'background-size: cover; background-repeat: no-repeat; background-position: center center; background-image: url(\'' + photoPreview + '\');'"
                            @click.prevent="selectNewPhoto">
                        </span>
                    </div>

                    <jet-secondary-button class="mt-2 mr-auto" type="button" @click.prevent="selectNewPhoto"
                        v-if="!hasLogo">
                        Select A New Logo
                    </jet-secondary-button>

                    <!-- <jet-secondary-button type="button" class="mt-2" @click.prevent="deletePhoto" v-if="team.photo_url">
                    Remove Logo
                </jet-secondary-button> -->

                    <jet-input-error :message="form.errors.photo" class="mt-2" />
                </div>
            </div>

            <!-- Team Owner Information -->

            <div class="col-span-1 flex flex-col justify-center text-sm text-gray-800">
                <jet-label value="Current Team Owner:" />
            </div>

            <div class="col-span-2 flex flex-col justify-center" :key="team_owner.id">

                <Listbox as="div" v-model="team_owner_id" @update:modelValue="updateTeamOwner">
                    <div class="relative">
                        <ListboxButton
                            class="grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pl-3 pr-2 text-left text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-birdie-blue sm:text-sm/6">
                            <span class="col-start-1 row-start-1 flex w-full gap-2 pr-6">
                                <span class="truncate">{{ team_owner.name }}</span>
                                <span class="truncate text-gray-500">{{ team_owner.email }}</span>
                            </span>
                            <ChevronUpDownIcon
                                class="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                                aria-hidden="true" />
                        </ListboxButton>

                        <transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100"
                            leave-to-class="opacity-0">
                            <ListboxOptions
                                class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-birdie-blue sm:text-sm">
                                <ListboxOption as="template" v-for="user in admins" :key="user.id" :value="user.id"
                                    v-slot="{ active, selected }">
                                    <li
                                        :class="[active ? 'bg-birdie-blue text-white outline-none' : 'text-gray-900', 'relative cursor-default select-none py-2 pl-3 pr-9']">
                                        <div class="flex">
                                            <span :class="[selected ? 'font-semibold' : 'font-normal', 'truncate']">{{
                                                user.name }}</span>
                                            <span
                                                :class="[active ? 'text-indigo-200' : 'text-gray-500', 'ml-2 truncate']">{{
                                                    user.email }}</span>
                                        </div>

                                        <span v-if="selected"
                                            :class="[active ? 'text-white' : 'text-gray-800', 'absolute inset-y-0 right-0 flex items-center pr-4']">
                                            <CheckIcon class="size-5" aria-hidden="true" />
                                        </span>
                                    </li>
                                </ListboxOption>
                            </ListboxOptions>
                        </transition>
                    </div>
                </Listbox>

            </div>

            <div class="col-span-6 text-sm text-gray-800">Birdie subdomain: <span class="font-mono bg-gray-100 py-0.5 px-2 text-sm">{{ team.slugname }}</span></div>
            <div class="col-span-6 text-sm text-gray-800">Your domain(s): <span class="font-mono bg-gray-100 py-0.5 px-2 text-sm">{{ team.team_domains.split(',').join(', ') }}</span>
            </div>

            <div v-if="false" class="col-span-2 flex flex-col justify-center text-sm text-gray-800">
                <div class="flex items-center" :key="team_owner.id">

                    <img v-if="team_owner.profile_photo_url && !profile_photo_error && profile_photo_loaded"
                        class="w-10 h-10 rounded-full object-cover text-xs" :src="team_owner.profile_photo_url"
                        alt="picture" @error="profile_photo_error = true" @load="profile_photo_loaded = true">

                    <div v-if="!team_owner.profile_photo_url || profile_photo_error || !profile_photo_loaded"
                        class="w-10 h-10 rounded-full object-cover bg-gray-200 flex items-center justify-center">
                        <!-- <UserIcon class="w-5 h-5 text-gray-400" /> -->
                        <span class="text-lg font-medium text-gray-600">{{
                            team_owner.name.substring(0,
                                1).toUpperCase() }}</span>
                    </div>


                    <div class="ml-4 leading-tight text-sm">
                        <div>{{ team_owner.name }}</div>
                        <div class="text-gray-700">{{ team_owner.email }}</div>
                    </div>
                </div>
            </div>
            <div v-if="false" class="col-span-4 flex flex-col justify-center">
                <div class="flex items-center" :key="team_owner.id">
                    <div class="">
                        <select id="owner" name="owner" v-model="team_owner_id"
                            class="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-gray-900 sm:text-sm/6"
                            @change="updateTeamOwner">
                            <option v-for="user in admins" :value="user.id" :selected="user.id == team_owner.id">{{
                                user.name }}</option>
                        </select>
                        <!-- <ChevronDownIcon
                            class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                            aria-hidden="true" /> -->
                    </div>

                    <!-- <div>
                        <select v-model="form.owner_id" class="mt-2">
                            <option v-for="user in admins" :value="user.id">{{ user.name }}</option>
                        </select>
                    </div> -->
                </div>
            </div>



        </template>

        <template #actions v-if="permissions.canUpdateTeam && false">
            <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                Saved.
            </jet-action-message>

            <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                Save
            </jet-button>
        </template>
    </jet-form-section>
</template>

<script>
import JetActionMessage from '@/Jetstream/ActionMessage'
import JetButton from '@/Jetstream/Button'
import JetFormSection from '@/Jetstream/FormSection'
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
// import { UserIcon } from "@heroicons/vue/20/solid";
import { ChevronDownIcon } from '@heroicons/vue/16/solid'
import { Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions } from '@headlessui/vue'
import { ChevronUpDownIcon } from '@heroicons/vue/16/solid'
import { CheckIcon } from '@heroicons/vue/20/solid'

export default {
    components: {
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        ChevronDownIcon,
        Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions,
        ChevronUpDownIcon,
        CheckIcon
        //UserIcon
    },

    props: ['team', 'permissions'],

    data() {
        return {
            form: this.$inertia.form({
                _method: 'PUT',
                name: this.team.name,
                photo: null,
            }),
            team_owner: this.team.owner,
            team_owner_id: this.team.owner.id,
            photoPreview: null,
            profile_photo_error: false,
            profile_photo_loaded: false,
            admins: [],
        }
    },

    created() {
        if (this.team.users) {
            if (this.team.users.length > 0) {
                for (var i = 0; i < this.team.users.length; i++) {
                    const user = this.team.users[i]
                    if (user.email_verified_at && user.enabled && user.active && user.membership.role == 'admin') {
                        this.admins.push(user)
                    }
                }
            }
        }
    },

    methods: {
        updateTeamName() {
            if (this.$refs.photo) {
                this.form.photo = this.$refs.photo.files[0]
            }
            this.form.post(route('teams.update', this.team), {
                errorBag: 'updateTeamName',
                preserveScroll: true,
                onSuccess: () => (this.clearPhotoFileInput()),
            });
        },
        updateTeamOwner(event) {
            console.log("updateTeamOwner", event, this.team_owner_id)
            if (this.team_owner_id != this.team_owner.id) {
                this.updateTeamOwner2()
            }

        },
        updateTeamOwner2() {
            if (this.saving) {
                return
            }
            this.saving = true
            let url = this.$page.props.api_url + '/v1/team/update';
            let params = {
                owner_id: this.team_owner_id
            }
            axios.post(url, params)
                .then(response => {
                    this.team_owner = response.data
                    let options = {
                        type: "default",
                        timeout: 6000,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Team Owner updated", options)
                    this.saving = false
                })
                .catch(e => {
                    console.error(e);
                    this.saving = false
                    let options = {
                        type: "danger",
                        timeout: -1,
                        position: "top-right"
                    }
                    this.$moshaToast("An error occurred", options)
                });

        },
        /*updateProfileInformation() {
            if (this.$refs.photo) {
                this.form.photo = this.$refs.photo.files[0]
            }

            this.form.post(route('user-profile-information.update'), {
                errorBag: 'updateProfileInformation',
                preserveScroll: true,
                onSuccess: () => (this.clearPhotoFileInput()),
            });
        },*/

        selectNewPhoto() {
            if (this.permissions.canUpdateTeam) {
                this.$refs.photo.click();
            }
        },

        updatePhotoPreview() {
            const photo = this.$refs.photo.files[0];

            if (!photo) return;

            const reader = new FileReader();

            reader.onload = (e) => {
                this.photoPreview = e.target.result;
            };

            reader.readAsDataURL(photo);
        },

        // deletePhoto() {
        //     this.$inertia.delete(route('current-user-photo.destroy'), {
        //         preserveScroll: true,
        //         onSuccess: () => {
        //             this.photoPreview = null;
        //             this.clearPhotoFileInput();
        //         },
        //     });
        // },

        clearPhotoFileInput() {
            if (this.$refs.photo?.value) {
                this.$refs.photo.value = null;
            }
        },
    },

    computed: {
        hasLogo() {
            if (this.team.team_logo_path) {
                return this.team.team_logo_path.substring(0, 22) != 'https://ui-avatars.com'
            }
            return false
        }
    }
}
</script>
